import { FormModule } from "./types";

import { formActions } from "./actions";
import { formState } from "./state";
import { formGetters } from "./getters";
import { formMutations } from "./mutations";

const formModule: FormModule = {
  namespaced: true,
  actions: formActions,
  getters: formGetters,
  mutations: formMutations,
  state: formState
};

export { formModule };
